import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListWithdrawRequest(authorization, filter) {
  const url = `${API_URL}/admin/transaction/withdraw`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getListPayout(authorization, filter) {
  const url = `${API_URL}/admin/transaction/payout`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getWithdrawHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/payout/history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setApproveReject(authorization, data) {
  const url = `${API_URL}/admin/transaction/withdraw/action`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setPayoutPayment(authorization, data) {
  const url = `${API_URL}/admin/transaction/payout/make-payment`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setPayoutSchedule(authorization, data) {
  const url = `${API_URL}/admin/transaction/payout/schedule`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getScheduledPayoutHistory(authorization) {
  const url = `${API_URL}/admin/transaction/payout/schedule-history`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getPendingPayoutReview(authorization) {
  const url = `${API_URL}/admin/transaction/payout/pending-review`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setPayoutReview(authorization, data) {
  const url = `${API_URL}/admin/transaction/payout/review`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getWiseBalance(authorization) {
  const url = `${API_URL}/admin/transaction/wise/balance`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setPayoutMarkPay(authorization, data) {
  const url = `${API_URL}/admin/transaction/payout/mark-pay`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/finance.js